import React from "react";
import { Index } from "../components/Blogs/Index";

export const Blogs = () => {
  return <Index />;
};
